if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        // new code
           const currentLevel = document.querySelector('.Certification_Level');

            if (currentLevel) {
                const errorDiv = document.querySelector('.certification_error');
                const radios = document.querySelectorAll('input[name="cert_level"]');

                // check if any radio is selected
                const isAnyRadioChecked = [...radios].some(r => r.checked);

                console.log("check>> ", isAnyRadioChecked);

                if (!isAnyRadioChecked) {
                    errorDiv.style.display = "block";
                    return;
                } else {
                    errorDiv.style.display = "none";
                }
            }
            // if currentLevel is not found, none of the code above will run

            //  new code end
        
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {


            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
              
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }

            // new code
            console.log('after message one');

            const form = document.querySelector('form[action="/cart/add"]');

            if (!form) return;

            form.addEventListener("submit", () => {
              // Trigger event for other tabs
              localStorage.setItem("refresh_cart", Date.now());
            });


            // var hazmatElement = document.getElementById('hazmat_value');
            // // Check if hazmat_value is 'true'
            // if (hazmatElement && hazmatElement.value === 'true') {
            //     // Fetch the current cart
            //     console.log('enter');
                
            //     fetch('/cart.js')
            //   .then(response => response.json())
            //   .then(cart => {
            //     console.log('Cart items:', cart.items);

            //     // Hazmat variant ID (must be a variant, not product ID)
            //     var hazmatVariantId = 50855241285929;

            //     // Check if Hazmat variant is already in the cart
            //     var productAlreadyInCart = cart.items.some(item => item.variant_id === hazmatVariantId);
            //     console.log('Hazmat already in cart? >>>', productAlreadyInCart);

            //     // Add Hazmat product only if total < 39900 and it's not already in cart
            //     if (cart.total_price < 39900 && !productAlreadyInCart) {
            //       fetch('/cart/add.js', {
            //         method: 'POST',
            //         headers: {
            //           'Content-Type': 'application/json'
            //         },
            //         body: JSON.stringify({
            //           id: hazmatVariantId,
            //           quantity: 1
            //         })
            //       })
            //         .then(response => response.json())
            //         .then(data => {
            //           console.log('Hazmat product added:', data);
            //         })
            //         .catch(error => {
            //           console.error('Error adding Hazmat product:', error);
            //         });
            //     } 
            //     else {
            //       console.log('No action needed');
            //     }
            //   })
            //   .catch(error => console.error('Error fetching cart:', error));




            // }

            // new code end



          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
         console.log('this is clicked');
           
console.log("jkjjk");

      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

         if (errorMessage) {
          this.errorMessage.textContent = errorMessage;

          // new test code
          
          if(errorMessage != "The maximum quantity of this item is already in your cart.")
           {
              //   window.location.href = "/cart";
              document.querySelector('#cart-notification').classList.add('active');
              
              const svgEl = document.querySelector('a#cart-icon-bubble svg');

                if (svgEl) {
                  svgEl.insertAdjacentHTML(
                    'beforeend',
                    '<circle cx="20" cy="6" r="5" fill="#D00A0A" stroke="white" stroke-width="2"></circle>'
                  );
                } 

             fetch('/cart.js')
              .then(response => response.json())
              .then(cart => {
                console.log('Cart items:', cart.items);

                // Update cart quantity in button
                const cartButton = document.getElementById('cart-notification-button');
                if (cartButton) {
                  cartButton.textContent = `View cart (${cart.item_count})`;
                }

                // Get selected variant id from your input
                const selectedVariantId = document.querySelector('.product-variant-id.zooomyvariantselect').value;
                const variantIdNum = Number(selectedVariantId);

                // Find matching cart item
                const item = cart.items.find(i => i.variant_id === variantIdNum);

                if (!item) {
                  console.warn("Variant not found in cart");
                  return;
                }

                // 👉 CHECK if variant options are real (not "Default Title")
                const hasRealVariant =
                  item.variant_title &&
                  item.variant_title !== "Default Title" &&
                  item.options_with_values &&
                  item.options_with_values.length > 0;

                // 👉 Build variant HTML only if real variant exists
                let variantHtml = "";
                if (hasRealVariant) {
                  variantHtml = `
                    <dl>
                      ${item.options_with_values
                        .map(opt => `
                          <div class="product-option">
                            <dt>${opt.name}:</dt>
                            <dd>${opt.value}</dd>
                          </div>
                        `)
                        .join('')}
                    </dl>
                  `;
                }

                // 👉 Build full HTML
                const html = `
                  <div class="cart-notification-product__image global-media-settings">
                    <img src="${item.image}&width=140" alt="" width="70" height="55" loading="lazy">
                  </div>

                  <div>
                    <h3 class="cart-notification-product__name h4">
                      ${item.product_title}
                    </h3>

                    ${variantHtml}
                  </div>
                `;

                // Insert into container
                document.getElementById('cart-notification-product').innerHTML = html;
              })
              .catch(err => console.error('Error fetching cart:', err));




           }
           //alert(errorMessage);
            // fetch('/cart.js')
            //   .then(response => response.json())
            //   .then(cart => {
            //     console.log('Cart items 2', cart.items);
            //        //this.cart.renderContents(cart.items);
            //   })
            //   .catch(error => console.error('Error fetching cart:', error));
 
           // new test code end
           
        }


        // new code
            console.log('after message two');


        //  var hazmatElement = document.getElementById('hazmat_value');

        //   // Check if hazmat_value is 'true'
        //   if (hazmatElement && hazmatElement.value === 'true') {
        //       console.log('Hazmat detected, waiting before checking cart...');

        //       // Fetch the current cart
        //       fetch('/cart.js')
        //           .then(response => response.json())
        //           .then(cart => {
        //               console.log('Cart items:', cart.items);

        //               setTimeout(function () {
        //                   // Hazmat variant ID (must be a variant, not product ID)
        //                   var hazmatVariantId = 50855241285929;

        //                   // Check if Hazmat variant is already in the cart
        //                   var productAlreadyInCart = cart.items.some(item => item.variant_id === hazmatVariantId);
        //                   console.log('Hazmat already in cart? >>>', productAlreadyInCart);

        //                   if (cart.total_price < 39900) {
        //                       if (!productAlreadyInCart) {
        //                           // ✅ Use update.js so Hazmat is always 1 qty only
        //                           fetch('/cart/update.js', {
        //                               method: 'POST',
        //                               headers: {
        //                                   'Content-Type': 'application/json'
        //                               },
        //                               body: JSON.stringify({
        //                                   updates: {
        //                                       [hazmatVariantId]: 1
        //                                   }
        //                               })
        //                           })
        //                               .then(response => response.json())
        //                               .then(data => {
        //                                   console.log('Hazmat product set to 1 qty:', data);
        //                               })
        //                               .catch(error => {
        //                                   console.error('Error updating Hazmat product:', error);
        //                               });
        //                       } else {
        //                           console.log('Hazmat already present, no duplicate add');
        //                       }
        //                   } else {
        //                       console.log('Cart total >= 39900, no Hazmat needed');
        //                   }
        //               }, 2000); // 2 second delay
        //           })
        //           .catch(error => console.error('Error fetching cart:', error));
        //   }



            // new code end

      }
    }
  );
}
